import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Role } from '../models/role';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class RoleService {

    constructor(private http: HttpClient) { }

    postRole(role: Role): Observable<any> {
        delete role.id;
        return this.http.post(`${environment.apiroot}/role`, role)
    }

    getListRole(params: any): Observable<any> {
        return this.http.get(`${environment.apiroot}/role`, { params })
    }

    getRole(idRole: string): Observable<any> {
        return this.http.get(`${environment.apiroot}/role/${idRole}`)
    }

    pathRole(role: Role): Observable<any> {
        return this.http.patch(`${environment.apiroot}/role/${role.id}`, role)
    }

    deleteRole(idRole: string): Observable<any> {
        return this.http.delete(`${environment.apiroot}/role/${idRole}`)
    }

    getListPermissions(): Observable<any> {
        return this.http.get(`${environment.apiroot}/permissions`)
    }
}